import { combineReducers } from 'redux';
import {
  INITIATE_PRIVY_LOGIN, PRIVY_LOGIN_SUCCESS, PRIVY_LOGIN_FAILURE,
  SET_PRIVY_USER, SET_AUTHENTICATED, LOGOUT_PRIVY_USER,SET_API_KEY,SET_PERSONAL_AI,REQUEST_PERSONAL_AI,PERSONAL_AI_ERROR
} from './actions';

import {  } from './actions';
import { message } from 'antd';

const initial = {
  app: {
    personalAI: [],
    personalAILoading: false,
    personalAIError: null,
  },
  privy:{
    user: null,
    authenticated: false,
    apiKey: null,
    // id: '',
    // createdAt: '',
    // linkedAccounts: [
    //   {
    //     address: '',
    //     type: 'wallet',
    //     verifiedAt: '',
    //     firstVerifiedAt: '',
    //     latestVerifiedAt: '',
    //     chainType: '',
    //     chainId: '',
    //     walletClient: '',
    //     walletClientType: '',
    //     connectorType: ''
    //   }
    // ],
    // wallet: {
    //   address: '',
    //   chainType: '',
    //   chainId: '',
    //   walletClient: '',
    //   walletClientType: '',
    //   connectorType: ''
    // },
    // delegatedWallets: [],
    // mfaMethods: [],
    // hasAcceptedTerms: false,
    // isGuest: false
  },
  msg:{}
};

const handlers = {
  app: {
  [SET_PERSONAL_AI]: (state, action) => {
    console.log('action.payload', action.payload);
    return {
      ...state,
      personalAI: action.payload,
      personalAILoading: false,
      personalAIError: null
    };
  },
  'UPDATE_PERSONAL_AI': (state, action) => {
    console.log(state.personalAI.map(persona => 
      persona.persona_id === action.payload.persona_id
        ? { ...persona, ...action.payload }
        : persona
    ), action.payload,state.personalAI)
    return {
      ...state,
      personalAI: state.personalAI.map(persona => 
        persona.persona_id === action.payload.persona_id
          ? { ...persona, ...action.payload }
          : persona
      ),
      personalAILoading: false,
      personalAIError: null
    };
  },
  [REQUEST_PERSONAL_AI]: (state) => {
    return {
      ...state,
      personalAILoading: true,
      personalAIError: null
    };
  },
  [PERSONAL_AI_ERROR]: (state, action) => {
    return {
      ...state,
      personalAILoading: false,
      personalAIError: action.payload
    };
  }},
  privy:{
    [SET_PRIVY_USER]: (state, action) => {
      return {
        ...state, user: action.payload, authenticated: true }
    },
    [SET_AUTHENTICATED]: (state, action) => {
      // message.error(action.payload.message);
      return {
        ...state, authenticated: action.payload
      };
    },
    [LOGOUT_PRIVY_USER]: (state, action) => {
      return {
        ...state, user: null, authenticated: false
      };
    },
    [SET_API_KEY]: (state, action) => {
      return {
        ...state, apiKey: action.payload
      };
    }
  },
  msg:{},
  // search: {
  //   [REQUEST_SUGGEST]: (state, action) => {
  //     return { ...state, status: 'working', error: false };
  //   },
  //   [SUCCESS_SUGGEST]: (state, action) => {
  //     return { ...state, status: 'done', error: false, suggests: action.payload.data };
  //   },
  //   [FAILURE_SUGGEST]: (state, action) => {
  //     return { ...state, status: 'done', error: true };
  //   },
  //   [CLEAR_SUGGESTS]: (state, action) => {
  //     return { ...state, suggests: initial.search.suggests.slice() };
  //   },
  //   [SET_KEYWORD]: (state, action) => {
  //     return { ...state, keyword: action.payload };
  //   },
  //   [CLEAR_KEYWORD]: (state, action) => {
  //     return { ...state, keyword: initial.search.keyword };
  //   }
  // }
};

function app(state = initial.app, action) {
  const handler = handlers.app[action.type];
  if (!handler) { return state; }
  return handler(state, action);
}

function privy(state = initial.privy, action) {
  const handler = handlers.privy[action.type];
  if (!handler) { return state; }
  return handler(state, action);
}

function msg(state = initial.msg, action) {
  const handler = handlers.msg[action.type];
  if (!handler) { return state; }
  return handler(state, action);
}



// const reducer = (state = initialState, action) => {
//     switch (action.type) {
//         // Login success, save address and token
//         case LOGINSUCCESS:
//             return { ...state, ...action.value };
//         case SAVEPRICE:
//             return { ...state, price: action.value };
//         case ADDMESSAGE:
//             return { ...state, message: [...state.message, action.value] };
//         case DELMESSAGE:
//             return {
//                 ...state,
//                 message: state.message.filter(item => {
//                     return item.index !== action.value;
//                 })
//             };
//         case SETLODING:
//             return { ...state, showLoding: action.value };
//         default:
//             return state;
//     }
// };

// export default reducer;
export default combineReducers(
  { app, privy, message}
);
